<template>
  <el-table
    :data="typesList"
    :stripe="true"
    :model="model"
    :show-header="false"
  >
    <el-table-column width="70" align="left">
      <template slot-scope="scope">
        <el-switch v-model="typesModel[scope.row.code]" />
      </template>
    </el-table-column>
    <el-table-column>
      <template slot-scope="scope">
        <div class="name">
          {{ scope.row.name }}
        </div>
        <div class="description" v-if="scope.row.description">
          {{ scope.row.description }}
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'MessageTypesList',

  props: {
    model: {
      type: Object,
      default: {}
    },

    typesList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },

  computed: {
    typesModel() {
      return this.model.params.message_types
    }
  }
}
</script>

<style scoped>
.el-table:before {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/webhook/MessageTypesList.vue